import React, { Component } from 'react';
import styled from 'styled-components';

import { Title } from '../style';

import ContactForm from '../ContactForm';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';

const Wrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: ${dark}90;
  z-index: 999999;
  display: ${props => (props.hide ? 'none' : 'block')};
`;

const Close = styled.div`
  color: ${primary};
  height: 36px;
  width: 36px;
  top: 108px;
  right: 12px;
  position: absolute;
  z-index: 999;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const Inner = styled.div`
  width: 95%;
  position: absolute;
  top: 108px;
  background-color: ${white};
  border-radius: 8px;
  max-width: 450px;
  left: 50%;
  transform: translateX(-50%);
  padding: 18px 24px;
  box-sizing: border-box;
  box-sizing: border-box;
  max-height: 600px;
  margin: 0;
`;
class Demo extends Component {
  close = () => {
    this.props.onChange();
  };

  render() {
    return (
      <Wrapper hide={this.props.hide}>
        <Close onClick={() => this.close()}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 352 512"
          >
            <path
              fill="currentColor"
              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            />
          </svg>
        </Close>
        <Inner>
          <Title
text={this.props.lang === 'fr' ? 'Demandez une démo' : 'Request a demo'}
color={primary} />
          <ContactForm
lang={this.props.lang}
light
dark
bg={white}
source={'Request Demo'} />
        </Inner>
      </Wrapper>
    );
  }
}

export default Demo;
